import { io } from 'socket.io-client'

const SOCKET_URL = process.env.VUE_APP_LIVE_STREAM

const socket = io(SOCKET_URL, {
  path: '/api/live/socket.io',
  transports: ['websocket', 'polling'],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  timeout: 60000
})

export default socket
